import React, {Component} from "react";
import currencyFormat from "../../helper/currencyFormat";
import {offerApiServices} from "../../services/offer/OfferApiService";
import {Button, Table} from "antd";
import {ClockCircleOutlined} from "@ant-design/icons";

class DetailCashbackAgent extends Component<any, any> {
    private readonly initState!: any;
    private tableColumn: any = [
        {
            title: 'Active',
            dataIndex: 'active',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{value?.toString()?.toUpperCase()}</span>
            })
        },
        {
            title: 'Status',
            dataIndex: 'cashback_status',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{value?.toString()}</span>
            })
        },
        {
            title: 'Type',
            dataIndex: 'cashback_type',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{(value) ? value : "agent"}</span>
            })
        },
        {
            title: 'Kode Agent/Affiliate',
            dataIndex: 'agent_code',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{value?.toString()}</span>
            })
        },
        {
            title: 'Nilai Cashback',
            dataIndex: 'cashback_amount',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{currencyFormat(Number(value))}</span>
            })
        },
        {
            title: 'Time Range',
            dataIndex: 'cashback_time_range',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{value?.toString()}</span>
            })
        },
        {
            title: 'Cashback Time',
            dataIndex: 'cashback_time',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{value?.substring(0, 10)}</span>
            })
        },
        {
            title: 'Minimum Payment',
            dataIndex: 'cashback_minimum_payment_terms',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{currencyFormat(Number(value))}</span>
            })
        },
        {
            title: 'Nilai yg sudah dibayar',
            dataIndex: 'cashback_paid_amount',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{currencyFormat(Number(value))}</span>
            })
        },
        {
            title: 'Kewajiban',
            dataIndex: 'cashback_responsibility',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{value}</span>
            })
        },
        {
            title: 'Catatan',
            dataIndex: 'notes',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{value}</span>
            })
        },
        {
            title: 'Kode Promo',
            dataIndex: 'promo_code',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{value}</span>
            })
        },
        {
            title: 'Bank',
            dataIndex: 'bank_code',
            render: ((value: string, row: any) => {
                return <span className={`font-90`}>{value?.toUpperCase()} {row?.bank_account_number}</span>
            })
        },
    ]

    constructor(props: any) {
        super(props);
        this.initState = {
            dataConfig: [],
            processingFetchTableData: false,
        }
        this.state = {...this.initState}
    }

    async componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (this.props.offerCode !== prevProps.offerCode) {
            await this.reloadData();
        }
    }

    async componentDidMount() {
        await this.reloadData();
    }

    onChangeTable = (pagination: any, filters: any, sorter: any) => {
        if (pagination?.pageSize) {
            this.setState({
                pageSize: pagination?.pageSize,
            });
        }
    }

    reloadData = async () => {
        const offerCode = this.props?.offerCode ?? "";

        await this.promisedSetState({
            processingFetchTableData: true,
            dataConfig: [],
        });

        offerApiServices.getDataCashbackAgent({
            offerCode: offerCode
        }).then((dataFetch) => {
            this.setState({
                dataConfig: dataFetch.data.data,
                processingFetchTableData: false,
            });
        }).catch(async (e) => {
            await this.promisedSetState({
                dataConfig: [],
                processingFetchTableData: false,
            });
            // console.log('Data Tidak Ditemukan');
        })
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>

                <Button size={"small"} onClick={this.reloadData} type="primary"><ClockCircleOutlined/> Reload Data Cashback</Button> <br/> <br/> <br/>

                <Table
                    rowKey={'warehouse_code'}
                    size={'small'}
                    scroll={{x: 'calc(500px + 50%)'}}
                    loading={this.state.processingFetchTableData}
                    columns={this.tableColumn}
                    dataSource={this.state.dataConfig}
                    pagination={{pageSize: this.state.pageSize}}
                    onChange={this.onChangeTable}
                />
            </React.Fragment>
        );
    }
}

export default DetailCashbackAgent;
